// extracted by mini-css-extract-plugin
export default {"root":"JzyRHt8EXMqv1AFuDZzz","flicker":"BUbabHx0x8CpNJuPzAzX","primary":"bNh_BIZsVOkb5bhIarkR","error":"aKYS0_x7nNgk9fKqsb9c"};